import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { DatePicker } from '@blueprintjs/datetime';
import { Popover } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { systemTimezoneAbbreviated } from '../helpers/time';

@observer
class BookingDateTimeInput extends React.Component {
  
  @observable value = moment();

  componentDidMount(){
    this.value = this.props.defaultValue || moment();
  }

  componentDidUpdate(){
    this.value = this.props.defaultValue || moment();
  }

  onChange = (selectedDate, isUserChange) => {
    if(!selectedDate){
      return
    }
    if(this.props.onChange){
      this.props.onChange(selectedDate, isUserChange);
    }
    this.value = moment(selectedDate);
  }

  datePicker() {
    return (
      <React.Fragment >
        <DatePicker
          minDate={moment().toDate()}
          value={ this.value.toDate() }
          onChange={this.onChange.bind(this)}
          timePrecision={'minute'}
          timePickerProps={{ useAmPm: true }}
          //minDate={this.props.minDate ? this.props.minDate.toDate() : moment().subtract(20, 'years').toDate() }
          maxDate={this.props.maxDate ? this.props.maxDate.toDate() : moment().add(365, 'days').toDate() }
        />
      </React.Fragment>
    )
  }

  render() {
    let {
			bookingStatus
		} = this.props;
    return (
      <Popover
        minimal={false}
        disabled={bookingStatus && bookingStatus === 'confirmed' ? true : false}
        position={'right'}
        content={this.datePicker.bind(this)()} >
        <input 
          className="bp3-input form-control bp3-fill"
          type="text"
          dir="auto"
          value={this.value.format('llll') + " " + systemTimezoneAbbreviated() }
          placeholder={this.props.placeholder}
          onChange={() => {}}
        />
      </Popover>
    )
  }
}

BookingDateTimeInput.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

export default BookingDateTimeInput;